module.exports = __webpack_public_path__ + "img/arrow-left.737acd59.svg";